/**************************************************
 * Nombre:       Formulario_Producto_Pedido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AddBoxOutlined, EmojiFoodBeverageOutlined, Google} from "@mui/icons-material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";

const Formulario_Producto_Pedido = ({...props}) => {
    const [categorias, setCategorias] = useState([]);

    useEffect(() => {
        obtenerCol('categorias').then(dox => {
            setCategorias(dox.data)
        })
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={EmojiFoodBeverageOutlined} nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={3} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={AddBoxOutlined} nombre={'Cantidad'} dato={'cantidad'} {...props}
                                  type={'number'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={Google} nombre={'Valor'} dato={'valor'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Pedido